import { useDispatch, useSelector } from 'react-redux';
import { EPResizeMax, EPResizeMin } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import Button from '@rsos/base-components/Button';
import {
  collapse,
  expand,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { AppState } from '../../../types/AppState';

interface Props {
  isLabelHidden?: boolean;
}

const CollapseButton = ({ isLabelHidden = false }: Props) => {
  const dispatch = useDispatch();
  const isCollapsed = useSelector(
    (state: AppState) => state.eventPane.isCollapsed,
  );
  const handleToggle = () => {
    if (isCollapsed) {
      dispatch(expand());
    } else {
      dispatch(collapse());
    }
  };

  return (
    <Button
      onClick={handleToggle}
      dataName="collapse-button"
      btnType="invisible"
      size="xxsmall"
      title={isLabelHidden ? 'Show more' : null}
      noMargin
    >
      {isCollapsed && (
        <EPResizeMax color="secondaryLink" width={12} height={12} />
      )}
      {!isCollapsed && (
        <EPResizeMin color="secondaryLink" width={12} height={12} />
      )}
      {!isLabelHidden && (
        <Text ml="5px" size="xsmall" lineHeight="normal">
          {isCollapsed ? 'Show more' : 'Show less'}
        </Text>
      )}
    </Button>
  );
};

export default CollapseButton;
